import React, { Component } from 'react';

class ErrorBoundary extends Component {
    constructor(props) {
        super(props);
        this.state = { hasError: false };
    }
    // static getDerivedStateFromError(error) {
    //     // Update state so the next render will show the fallback UI.
    //     return this.setState({hasError:true})
    //     // return { hasError: true };
    // }

    componentDidCatch(error, errorInfo) {
        this.setState({hasError:true})
        // You can also log the error to an error reporting service
        // console.error('Error caught by error boundary:', error, errorInfo);
    }

    render() {
        if (this.state.hasError) {
            // You can render any custom fallback UI here
            return <h1>Something went wrong.</h1>;
        }

        return this.props.children;
    }
}

export default ErrorBoundary;
